<template>
  <footer class="footer_section">
    <div class="footer-more">
      <div class="footer-more-con w">
        <div class="company-profile">
          <div class="logo">
            <img src="../assets/logo.png" alt="logo" />
          </div>
          <div class="introduce">
            专注于私域工具开发及运营，为大中小淘客提供周到、放心的一站式服务。
          </div>
        </div>
        <div class="other-business">
          <div
            class="business-list"
            v-for="(item, index) in businessList"
            :key="index"
          >
            <div class="list-tit">{{ item.title }}</div>
            <div class="list-content">
              <img
                v-if="item.qrcode"
                v-viewer
                class="qrcode"
                :src="item.qrcode"
                alt=""
              />
              <a
                v-else
                class="list-content-item"
                v-for="(itm, idx) in item.list"
                :key="idx"
                :href="itm.to"
                target="_blank"
              >
                {{ itm.title }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="internet-content-provider">
      <span>Copyright © 广州言成科技有限公司</span>
      <a href="https://beian.miit.gov.cn/" target="_blank">
        粤ICP备19034313号
      </a>
    </div>
  </footer>
</template>

<script>
// import checkHost from "../../public/host";
export default {
  name: "Footer",
  data() {
    // 参数
    return {
      beian: {},
      businessList: [
        {
          title: "帮助支持",
          list: [
            { title: "在线文档", to: "https://saas.tuielf.com/supplier" },
            { title: "常见问题", to: "https://saas.tuielf.com/supplier" },
            { title: "生活服务", to: "https://saas.tuielf.com/supplier" },
          ],
        },
        {
          title: "快捷链接",
          list: [
            { title: "淘宝联盟", to: "http://pub.alimama.com" },
            { title: "京东联盟", to: "https://union.jd.com" },
            { title: "多多进宝", to: "https://jinbao.pinduoduo.com" },
          ],
        },
        {
          title: "关注我们",
          qrcode: require("../assets/qrcode.jpg"),
        },
      ],
    };
  },
  created() {
    // const beian = checkHost("86ln.com");
    // const beian = checkHost(window.location.host);
    const beian = localStorage.getItem("beian");
    this.beian = JSON.parse(beian);
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.footer_section {
  background-color: #fff;

  .footer-more {
    padding: 60px 0;
    border-bottom: 1px solid #e5e6eb;

    .footer-more-con {
      padding: 0 20px;
      display: flex;
    }

    .company-profile {
      width: 236px;

      .logo {
        img {
          width: 82px;
          // height: 24px;
        }
      }

      .introduce {
        margin-top: 44px;
        font-size: 14px;
        color: #4e5969;
      }
    }

    .other-business {
      margin-left: 400px;
      flex: 1;
      display: flex;
      justify-content: space-between;

      .list-tit {
        margin-bottom: 26px;
        font-weight: 500;
        font-size: 18px;
      }

      .list-content {
        display: flex;
        flex-direction: column;
        align-items: center;

        .list-content-item {
          margin-bottom: 6px;
          font-size: 14px;
          color: #4e5969;
          text-align: center;
        }

        .qrcode {
          width: 78px;
          height: 78px;
        }
      }
    }
  }

  .internet-content-provider {
    padding: 60px 0 30px;
    text-align: center;
    font-size: 14px;
    color: #4e5969;

    a {
      color: #4e5969;
    }
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
}

@media (min-width: 768px) and (max-width: 991px) {
  .footer_section {
    .footer-more {
      .other-business {
        margin-left: 200px;
      }
    }
  }
}

@media (max-width: 767px) {
  .footer_section {
    .footer-more {
      .footer-more-con {
        display: block;
      }
      .company-profile {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        .introduce {
          margin-top: 20px;
          text-align: center;
        }
      }
      .other-business {
        margin: 20px 0 0;
      }
    }

    .internet-content-provider {
      padding: 30px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>
